// Import everything from autoload folder
import './autoload/_bootstrap.js'; import './autoload/ada-compliance.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import { Fancybox } from '@fancyapps/ui';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import ScrollOut from 'scroll-out';

ScrollOut({
  threshold: 0.35,
  once: true,
});

import Lenis from 'lenis';

const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

import Swiper, {
  Autoplay,
  FreeMode,
  Navigation,
  Pagination,
  EffectCoverflow,
  Thumbs,
  Lazy,
} from 'swiper';

Swiper.use([
  Autoplay,
  FreeMode,
  Navigation,
  Pagination,
  Thumbs,
  EffectCoverflow,
  Lazy,
]);
var servicesSlider = new Swiper('.services-slider', {
  direction: 'horizontal', // Slider direction (horizontal or vertical)
  slidesPerView: 3.4,
  spaceBetween: 20,
  loop: true, // Infinite loop
  speed: 3500, // Transition speed in milliseconds
  autoplay: {
    delay: 4000, // Autoplay delay in milliseconds
    disableOnInteraction: false, // Stop autoplay on user interaction
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
  breakpoints: {
    0: {
      enabled: true,
      slidesPerView: 1.4,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 1.4,
      spaceBetween: 8,
    },
    1024: {
      slidesPerView: 2.2,
      spaceBetween: 15,
    },
    1280: {
      slidesPerView: 2.5,
      spaceBetween: 15,
    },
    1440: {
      slidesPerView: 3.4,
      spaceBetween: 20,
    },
  },
});

/**
 * Fit slide video background to video holder
 */
// function resizeVideo() {
//   let $holder = $('.videoHolder');
//   $holder.each(function () {
//     let $that = $(this);
//     let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
//     let width = parseFloat(ratio.split(':')[0]);
//     let height = parseFloat(ratio.split(':')[1]);
//     $that.find('.video').each(function () {
//       if ($that.width() / width > $that.height() / height) {
//         $(this).css({
//           width: '100%',
//           height: 'auto',
//         });
//       } else {
//         $(this).css({
//           width: ($that.height() * width) / height,
//           height: '100%',
//         });
//       }
//     });
//   });
// }

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  servicesSlider.init();
  const burger = document.querySelector('.navbar-toggler');
  const logo = document.querySelector('.logo');
  const body = document.querySelector('body');
  const html = document.querySelector('html');
  burger.addEventListener('click', () => {
    const nav = document.getElementById('main-navigation');
    const isOpen = nav.classList.contains('show');
    if (!isOpen) {
      logo.classList.add('logo-active');
      body.classList.add('no-scroll');
      html.classList.add('no-scroll');
    } else {
      logo.classList.remove('logo-active');
      body.classList.remove('no-scroll');
      html.classList.remove('no-scroll');
    }
  });

  const hash = window.location.hash;
  if (hash) {
    const target = document.querySelector(hash);
    if (target) {
      setTimeout(() => {
        const offset = window.innerWidth <= 768 ? -150 : -250;
        lenis.scrollTo(target, {
          offset: offset,
          duration: 2.5,
          easing: (t) => t,
        });
      }, 300);
    }
  }
  document.querySelectorAll('#main-navigation a[href^="#"]').forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        lenis.scrollTo(target, {
          offset: -250,
          duration: 2.5,
          easing: (t) => t,
        });
      }
      document.getElementById('main-navigation').classList.remove('show');
    });
  });
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  $('.gallery-item')
    .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
    .attr('rel', 'gallery')
    .attr('data-fancybox', 'gallery');

  Fancybox.bind('[data-fancybox]');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    // jQuery code goes here
  });

  // resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  // resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
  if ($(this).scrollTop() > 10) {
    $('header').addClass('scrolled');
  } else {
    $('header').removeClass('scrolled');
  }
});
